Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.StyledHeadingText = exports.StyledLabelsContainer = exports.StyledGaugeLabel = void 0;

var _styledComponents = _interopRequireDefault(require('../../styled-components'));

var _Text = require('../Text');

var _Heading = require('../Heading');

var _colors = require('../../utils/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(['\n    margin-right: ', ';\n']);
  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([
    '\n    display: flex;\n    width: 100%;\n    margin-bottom: -13px;\n    align-items: baseline;\n'
  ]);
  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(['\n    color: ', ';\n']);
  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var StyledGaugeLabel = (0, _styledComponents.default)(_Text.Text)(_templateObject(), function (props) {
  return (0, _colors.getRGBOpacity)(props.theme.colors.primaryFont, 0.3);
});
exports.StyledGaugeLabel = StyledGaugeLabel;

var StyledLabelsContainer = _styledComponents.default.div(_templateObject2());

exports.StyledLabelsContainer = StyledLabelsContainer;
var StyledHeadingText = (0, _styledComponents.default)(_Heading.Heading)(_templateObject3(), function (props) {
  return props.marginRight;
});
exports.StyledHeadingText = StyledHeadingText;
